export const isFunc = (fn: any): fn is () => void => typeof fn === "function";
export const isString = (str: any): str is string => typeof str === "string";
export const isObject = (obj: any): obj is object => typeof obj === "object";
export const isArray = (arr: any): arr is any[] => Array.isArray(arr);
